module.exports = __webpack_public_path__ + "img/Bom-active.09e84d6e.png";